import { createSelector } from 'reselect'

import { checkPerm } from 'utils/permManager'

import {
  selectActualCompanyId,
  selectActualCompanyName,
  selectActualPermissions,
  selectIsActualCompanyDataReady,
  selectPartner,
} from 'containers/App/selectors'
import {
  CREATED_BY_LABELS,
  CREATED_BY_OPTIONS,
  CREATED_BY_VALUES,
} from 'containers/AwarenessCenter/WizardCampaign/steps/ScenariosStep/constants'
import { selectCompanyFilter, selectCompanyLoader } from 'containers/PartnerOptions/selectors'

export const selectDuplicateDisabledReason = (state) => {
  if (
    (selectPartner(state) && !(selectCompanyFilter(state)?.value > 0)) ||
    !selectIsActualCompanyDataReady(state) ||
    selectCompanyLoader(state)
  )
    return 'Select a company first'
  if (!checkPerm(selectActualPermissions(state), ['admin', 'edit_campaigns']))
    return 'You do not have permission to create templates for this company.'
  return ''
}

export const selectDuplicateCompanyId = (state) =>
  selectDuplicateDisabledReason(state) ? null : selectActualCompanyId(state)

const selectLoader = (state) => state.awarenessCenter.scenarios.loader
const selectError = (state) => state.awarenessCenter.scenarios.error
const selectData = (state) => state.awarenessCenter.scenarios.data

const selectTypeFilter = (state) => state.awarenessCenter.scenarios.typeFilter
const selectLevelFilter = (state) => state.awarenessCenter.scenarios.levelFilter
const selectCategoryFilter = (state) => state.awarenessCenter.scenarios.categoryFilter
const selectCreatedByFilter = (state) => state.awarenessCenter.scenarios.createdByFilter
const selectMessage = (state) => state.awarenessCenter.scenarios.message
const selectLanguagesFilter = (state) => state.awarenessCenter.scenarios.languagesFilter
const selectPage = (state) => state.awarenessCenter.scenarios.page
const selectSortProperty = (state) => state.awarenessCenter.scenarios.sortProperty
const selectCreatedCampaignId = (state) => state.awarenessCenter.scenarios.createdCampaignId

const selectCreatedByOptions = createSelector(
  selectActualCompanyName,
  selectPartner,
  (companyName, partner) => {
    const optionsArray = [...CREATED_BY_OPTIONS]
    if (partner) {
      optionsArray.push({
        label: CREATED_BY_LABELS[CREATED_BY_VALUES.SERVICE_PROVIDER],
        value: CREATED_BY_VALUES.SERVICE_PROVIDER,
      })
    }
    return [...optionsArray, { value: 4, label: companyName }]
  }
)

export {
  selectLoader,
  selectError,
  selectData,
  selectTypeFilter,
  selectLevelFilter,
  selectCategoryFilter,
  selectLanguagesFilter,
  selectPage,
  selectMessage,
  selectSortProperty,
  selectCreatedByOptions,
  selectCreatedByFilter,
  selectCreatedCampaignId,
}
